import {cookieStore, localStore} from 'libs/storage/storage';
import {getUrlParameter} from 'libs/url/url';

export const AFF_ID_STORE_PARAM = 'gusa_aff_id';

/**
 * Normalize default value affiliate id from backend
 * @param {string} affId - affiliate id
 * @returns {string} - normalize affiliate id
 */
export function normalizeAffId(affId?: string): string {
    return affId && affId !== 'undefined' ? affId : '';
}

/**
 * Migrates affiliate ID from local storage to cookie storage.
 * Since AFF_ID data is required for properly server-side rendering(CMS banners), the function safely moves AFF_ID from store to store
 * to save marketing programs for customers that already have stored an affiliate ID.
 * @param {string} affIdFromLocalStorage - affiliate ID stored in localStorage
 */
const migrateAffiliateIdStorages = (affIdFromLocalStorage: string) => {
    cookieStore.set(AFF_ID_STORE_PARAM, affIdFromLocalStorage);
    localStore.remove(AFF_ID_STORE_PARAM);
};

type GetAffIdArgType = {
    cookies?: {[key: string]: string};
    search?: string;
};

/**
 * Get actual affiliate id.
 *
 * Affiliates have a priority, where:
 * URL - high (https://glassesusa.com?affid=AFFILIATE_ID)
 * localStorage - low (gusa_aff_id)
 * @param {object} [cookies] - cookies data that can be passed optionally(f.e. to use it on server side)
 * @return {string} affiliate id
 */
export const getAffId = (arg?: GetAffIdArgType) => {
    const affIdFromUrl = getUrlParameter('affid', arg?.search);
    const affIdFromLocalStorage = localStore.get(AFF_ID_STORE_PARAM);

    if (affIdFromLocalStorage) {
        migrateAffiliateIdStorages(affIdFromLocalStorage);
    }
    const affIdFromStorage =
        arg?.cookies?.[AFF_ID_STORE_PARAM] || cookieStore.get(AFF_ID_STORE_PARAM);
    return affIdFromUrl || affIdFromStorage || '';
};
